import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/tuyen-dung/ung-vien'
const YC = '/tuyen-dung/yeu-cau-tuyen-dung'

// Lọc danh sách ứng viên
export function locUngVien(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách ứng viên theo yêu cầu tuyển dụng
export function layDanhSachUngVienTheoYeuCau(recruitmentRequestId: number) {
  try {
    return axiosApi.get(`${YC}/${recruitmentRequestId}/danh-sach-ung-vien`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết ứng viên
export function layChiTietUngVien(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo ứng viên
export function taoUngVien(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật ứng viên
export function capNhatUngVien(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa ứng viên
export function xoaUngVien(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật giai đoạn ứng viên
export function capNhatGiaiDoanUngVien(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat-giai-doan`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo bình luận ứng viên
export function taoBinhLuanUngVien(candidateId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${candidateId}/tao-binh-luan`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách bình luận ứng viên
export function layDanhSachBinhLuanUngVien(candidateId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/${candidateId}/binh-luan`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
